import axios from './BaseService';

const TWOFA_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/2fa`;

export async function getStatus() {
    const response = await axios.get(`${TWOFA_URL}/status`);
    return response.data;
}

export async function setup() {
    const response = await axios.post(`${TWOFA_URL}/setup`, {});
    return response.data;
}

export async function enable(token) {
    const response = await axios.post(`${TWOFA_URL}/enable`, { token });
    return response.data;
}

export async function disable(token) {
    const response = await axios.post(`${TWOFA_URL}/disable`, { token });
    return response.data;
}
